import React from "react";
import BaseReportPage from "./_BaseReportPage";

const columns = [
  { title: "Date", key: "date" },
  { title: "Code", key: "employee_code" },
  { title: "Name", key: "name" },
  { title: "In", key: "in_time" },
  { title: "Out", key: "out_time" },
  { title: "Missing", key: "missing" }, // backend should provide `missing` field (e.g. "OUT at 17:32")
  { title: "Remark", key: "remark" },
];

export default function MissedReportPage() {
  return <BaseReportPage columns={columns} title="Missed Punch Report" emptyMessage="No missed punch records" />;
}
